import Api from '@/services/Api'

// Dnevnik knjizenja - proknjizeni dokumenti kronoloski, samo citanje.
export default {

  // Jedan redak po dokumentu: {CompanyId, BusinessYear, odDatuma, doDatuma}
  dokumenti (query) {
    return Api().get('dnevnik/dokumenti', {params: query})
  },

  // Stavke jednog dokumenta ({CompanyId, MainLedgerId}) ili cijelog razdoblja
  // (isti uvjeti kao dokumenti).
  stavke (query) {
    return Api().get('dnevnik/stavke', {params: query})
  }
}
